export default __webpack_public_path__ + "static/media/heritage2.7f47292b.png";